'use client';

import React, { useState, useEffect } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classes from './errroNotification.module.scss';
import ErrorNotificationIcon from '@/icons/errorNotification';
import LayoutDashboard from '../Dashboard';
import { useStore } from '@/store/zustand-solicitud';
import { useRouter } from 'next/navigation';
import { sufijoModoAsistido } from '@/utils/services/modoAsistido';

interface ErrorNotificationProps {
  title: string;
  subtitle: string;
  route?: string;
  buttonText?: string;
  typeError?: 'warning' | 'danger';
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({ title, subtitle, typeError = 'danger', route = '', buttonText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { setNavbarVisible, entidadId, type, color } = useStore();
  const router = useRouter();
  const idSolicitudJuridica = sessionStorage.getItem('solicitudJ') || '';
  const ref_id = sessionStorage.getItem('ref_id') || '';

  const redirect = () => {
    if (entidadId) {
      if (route) {
        router.push(route);
        return;
      }
      let solicitudJuridicaIdRoute = '';
      if (idSolicitudJuridica) {
        solicitudJuridicaIdRoute = `&s=${idSolicitudJuridica}`;
      }
      // El modo asistido se arrastra porque esta url se rearma desde cero y el parametro original
      // ya no esta: sin esto el operador vuelve en modo autoasistido y le reaparece el check de
      // terminos, que no puede aceptar (AB#10758).
      const modoAsistidoRoute = sufijoModoAsistido();
      if (type) {
        router.push(`/?e=${entidadId}&t=${type}&ref_id=${ref_id}` + solicitudJuridicaIdRoute + modoAsistidoRoute);
      } else {
        router.push(`/?e=${entidadId}&ref_id=${ref_id}` + solicitudJuridicaIdRoute + modoAsistidoRoute);
      }
    } else {
      router.push('/');
    }
  };


  return (
    <LayoutDashboard>
      <div className={classes.container}>
        <div
          className={`${classes.card} ${typeError === 'warning' ? classes.warning : classes.danger}`}
          style={{ borderRadius: '20px', padding: '20px' }}
        >
          <div className={classes.content}>
            <ErrorNotificationIcon
              className={`${classes.icon} ${typeError === 'danger' ? classes.dangerIcon : classes.warningIcon}`}
              type={typeError}
            />
            <h3 className={`${classes.title} ${typeError === 'danger' ? classes.dangerTitle : classes.warningTitle}`}>{title}</h3>
            <p className={classes.subtitle}>{subtitle}</p>

            {entidadId && (
              <button className={classes.closeButton} style={{ backgroundColor: color }} onClick={redirect}>
                {buttonText || 'Volver al inicio'}
              </button>
            )}
          </div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default ErrorNotification;
